import STATISTICS_API from 'api/statistics/v2'
import omit from 'lodash/omit'
import { call, put, select, takeLatest } from 'redux-saga/effects'
import prepareFilterParams from 'utils/prepareFilterParams'
import { notificationShow } from 'modules/Notifications/actions'

function* getFilters() {
  const filtersState = yield select((state) => ({
    ...state['statistics/filters'].filters,
    ...state['statistics'].filters,
  }))

  return omit(prepareFilterParams(filtersState), ['include_vat'])
}

function* statisticsFetchChart({ isDemoMode }) {
  try {
    const filtersState = yield call(getFilters)

    const params = { ...filtersState }

    yield put({ type: 'STATISTICS/FETCH_CHART_START', payload: 'chart' })

    const { response, error } = yield call(
      isDemoMode ? STATISTICS_API.fetchChartDemo : STATISTICS_API.fetchChart,
      {
        params: params,
      },
    )

    if (error) {
      throw error
    }

    const { data = [], summary = {} } = response

    yield put({ type: 'STATISTICS/SET_CHART', payload: { data, summary } })
  } catch (error) {
    yield put({ type: 'STATISTICS/FETCH_FAIL', payload: 'chart' })
    console.logXHR(error)
  }
}

function* fetchStatisticsTable({
  payload: { group_by, limit, offset },
  isDemoMode,
}) {
  try {
    yield put({ type: 'STATISTICS/FETCH_TABLE_START', payload: 'table' })

    let METHOD

    switch (group_by) {
      case 'accounts':
        METHOD = isDemoMode
          ? STATISTICS_API.fetchAccountsStatisticsDemo
          : STATISTICS_API.fetchAccountsStatistics
        break
      case 'networks':
        METHOD = isDemoMode
          ? STATISTICS_API.fetchNetworksStatisticsDemo
          : STATISTICS_API.fetchNetworksStatistics
        break
    }

    const filtersState = yield call(getFilters)

    const params = {
      ...filtersState,
      limit: limit,
      offset: offset,
    }

    const { response, error } = yield call(METHOD, {
      params: params,
    })

    if (error) {
      throw error
    }

    const { data = [], summary, pagination } = response

    yield put({
      type: 'STATISTICS/SET_TABLE',
      payload: { data, summary, pagination },
    })
  } catch (error) {
    yield put({ type: 'STATISTICS/FETCH_FAIL', payload: 'table' })
    yield put(
      notificationShow({
        type: 'error',
        message: 'common::notifications.data_fetch_failed',
      }),
    )
    console.logXHR(error)
  }
}

export default function* Sagas() {
  yield takeLatest('STATISTICS/FETCH_CHART', statisticsFetchChart)
  yield takeLatest('STATISTICS/FETCH_TABLE', fetchStatisticsTable)
}
